import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';

import { useAuth } from '@/app/auth-context';

/**
 * Redirects to `/login` when no session is present, preserving the originally
 * requested path so the login flow can return there on success.
 */
export function ProtectedRoute({ children }: { children: ReactNode }): JSX.Element {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <>{children}</>;
}
